<template>
  <simple-space size="6">
    <tag-label v-for="(label, index) in labels" :label="label" :key="index" />
  </simple-space>
</template>

<script>
import SimpleSpace from 'components/business/expense-list/detail/simple-space';
import TagLabel from 'components/business/label/tag-labels/tag-label';
export default {
  name: 'tag-labels',
  props: {
    labels: {
      type: Array,
    },
    compression: {
      type: Boolean,
    },
    entityType: {
      type: Number,
    },
  },
  components: {
    SimpleSpace,
    TagLabel,
  },
};
</script>
